module.exports = __webpack_public_path__ + "static/media/project-name.bac727e9.png";